import { useEffect, useState } from "react";
import { planApi } from "../../data/api/PlanApi";
import { Plan, PlanResource } from "../../data/models/Plan/PlanModel";

export function useAdminPlansPage() {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const { data } = await planApi.allPlans.request(null);
      const ordered = [...(data ?? [])].sort((a, b) => {
        const priority = ["MY_KIT", "PLAN_PRO"];
        const indexA = priority.indexOf(a.code);
        const indexB = priority.indexOf(b.code);
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return 0;
      });
      setPlans(ordered);
    } finally {
      setLoading(false);
    }
  };

  const pushNewPlanResource = async (resource: PlanResource) => {
    try {
      await planApi.pushNewResource.request({ resource });
      fetchPlans();
    } finally {
      setLoading(false);
    }
  };

  const deletePlanResource = async (resource: PlanResource) => {
    try {
      await planApi.deleteResource.request({ resource });
      fetchPlans();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return { plans, loading, pushNewPlanResource, deletePlanResource };
}
